module.exports = __webpack_public_path__ + "static/img/5_1_2.d7ef283c.jpg";